









function toTitleCase(str) { return str.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();}); }










var checkExist = setInterval(function() {

    if ( $('div.collection-listing').length ) {

        total_products = [];

        if ( location.href.indexOf('?') !== -1 ) {
            url_tags = location.href.split('?').pop().split('&');
        } else {
            url_tags = []
        }

        product_type = [];
        new_product = [];
        grade_level = [];
        genre = [];
        series = [];
        subseries = [];
        grl = [];
        il = [];
        all_tags = [];

        for ( i = 0; i < url_tags.length; i++ ) {

            k = url_tags[i].split('=')[0];
            v = url_tags[i].split('=')[1];

            if (k == 'product-type') product_type.push(v);
            if (k == 'new') new_product.push(v);
            if (k == 'grade-level') grade_level.push(v);
            if (k == 'genre') genre.push(v);
            if (k == 'series') series.push(v);
            if (k == 'subseries') subseries.push(v);
            if (k == 'guided-reading-level') grl.push(v);
            if (k == 'intervention-level') il.push(v);
            all_tags.push(v);

        }

        $.each($('div.collection-listing').children('div.product-listing'), function() {

            tags = $(this).data('tags').split(';');

            included = ((product_type.some(v => tags.includes(v)) || product_type.length == 0) && (new_product.some(v => tags.includes(v)) || new_product.length == 0) && (grade_level.some(v => tags.includes(v)) || grade_level.length == 0) && (genre.some(v => tags.includes(v)) || genre.length == 0) && (series.some(v => tags.includes(v)) || series.length == 0) && (subseries.some(v => tags.includes(v)) || subseries.length == 0) && (grl.some(v => tags.includes(v)) || grl.length == 0) && (il.some(v => tags.includes(v)) || il.length == 0))

            if ( !included ) {
                $(this).detach();
            } else {
                $(this).css('display', 'block');
                $(this).find('select.varid').prop('selectedIndex', 0);
                total_products.push($(this));
            }

        });

        $('#total-products').html('1 of ' + total_products.length + ' (' + total_products.length + ' Products)');
        $('#total-products-bottom').html('1 of ' + total_products.length + ' (' + total_products.length + ' Products)');

        if (total_products.length == 0) {
            $('div.collection-listing').html("<p style = 'line-height: 29px;'>Sorry, there are no products that meet the search criteria you've selected. For further assistance, contact us at toll-free 866-918-6173 or email us at Info@HamerayPublishing.com. If you would like a price quote for a custom list of books or book sets, <b><a href = 'https://www.hameraypublishing.com/pages/quote-request'>please fill out our Quote Form here</a></b>.</p><br>");
        }

        $.each($('a.filter-link'), function() {

            filter_option = $(this).parent().attr('data-filter-option');
            filter_pair = $(this).parent().attr('data-filter-group') + '=' + filter_option
            filter_remove_url = window.location.href.replace(filter_pair, '')

            if (filter_remove_url.substr(filter_remove_url.length - 1) == '&') {
                filter_remove_url = filter_remove_url.substring(0, filter_remove_url.length-1);
            }

            if (filter_remove_url.substr(filter_remove_url.length - 1) == '?') {
                filter_remove_url = filter_remove_url.substring(0, filter_remove_url.length-1);
            }

            filter_remove_url = filter_remove_url.replace('?&', '?');
            filter_remove_url = filter_remove_url.replace('&&', '&');

            if (all_tags.includes(filter_option)) {
                $(this).parent().addClass('active');
                current_filter_title = toTitleCase(filter_option.replace(/-/g, ' ')).replace(' Cd', ' CD').replace(' Y ', ' y ').replace(' El ', ' el ').replace(' De ', ' de ').replace(' Las ', ' las ').replace(' Los ', ' los ').replace(' La ', ' la ').replace(' And ', ' and ').replace(' The ', ' the ');
                $('ul#filter-current').append('<li class = "active"><a href = "' + filter_remove_url + '">' + current_filter_title + '</a></li>');
            } else {
                $(this).parent().removeClass('active');
            }

        });

        $('a.filter-link').click(function(event) {

            event.preventDefault();

            current_url = window.location.href;

            param = $(this).parent().attr('data-filter-group') + '=' + $(this).parent().attr('data-filter-option');

            if (current_url.indexOf(param) !== -1) {

            current_url = current_url.replace(param, '');

            if (current_url.substr(current_url.length - 1) == '&') {
                current_url = current_url.replace('&', '');
            }

            if (current_url.substr(current_url.length - 1) == '?') {
                current_url = current_url.replace('?', '');
            }

            current_url = current_url.replace('?&', '?');
            current_url = current_url.replace('&&', '&');

            } else {

            if (current_url.indexOf('?') > -1) {
                current_url += '&' + param;
            } else {
                current_url += '?' + param;
            }

            }

            window.location.href = current_url;

        });

        clearInterval(checkExist);
 
    }
 
}, 100);









